/**
 * Replace Invoice Attachment Use Case
 *
 * Business logic for replacing invoice attachment following clean architecture principles.
 */

import {SalesDashboardRepository} from '../repository/SalesDashboardRepository';
import {InvoiceAttachmentDTO} from '../api/SalesDashboardAPIDataSource';

export class ReplaceInvoiceAttachmentUseCase {
  constructor (private repository: SalesDashboardRepository) {}

  async execute (invoiceId: string | number, file: File): Promise<InvoiceAttachmentDTO> {
    if (file.type !== 'application/pdf') {
      throw new Error('يرجى اختيار ملف PDF فقط');
    }

    return await this.repository.replaceInvoiceAttachment(invoiceId, file);
  }
}
